'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var effects = require('redux-saga/effects');

/* This file is generated. Do not edit it. */

/* This file is generated. Do not edit it. */
function* take(...args) {
  return yield effects.take(...args);
}

/* This file is generated. Do not edit it. */
function* takeMaybe(...args) {
  return yield effects.takeMaybe(...args);
}

/* This file is generated. Do not edit it. */
function* takeEvery(...args) {
  return yield effects.takeEvery(...args);
}

/* This file is generated. Do not edit it. */
function* takeLatest(...args) {
  return yield effects.takeLatest(...args);
}

/* This file is generated. Do not edit it. */
function* takeLeading(...args) {
  return yield effects.takeLeading(...args);
}

/* This file is generated. Do not edit it. */
function* put(...args) {
  return yield effects.put(...args);
}

/* This file is generated. Do not edit it. */
function* putResolve(...args) {
  return yield effects.putResolve(...args);
}

/* This file is generated. Do not edit it. */
function* call(...args) {
  return yield effects.call(...args);
}

/* This file is generated. Do not edit it. */
function* apply(...args) {
  return yield effects.apply(...args);
}

/* This file is generated. Do not edit it. */
function* cps(...args) {
  return yield effects.cps(...args);
}

/* This file is generated. Do not edit it. */
function* fork(...args) {
  return yield effects.fork(...args);
}

/* This file is generated. Do not edit it. */
function* spawn(...args) {
  return yield effects.spawn(...args);
}

/* This file is generated. Do not edit it. */
function* join(...args) {
  return yield effects.join(...args);
}

/* This file is generated. Do not edit it. */
function* cancel(...args) {
  return yield effects.cancel(...args);
}

/* This file is generated. Do not edit it. */
function* select(...args) {
  return yield effects.select(...args);
}

/* This file is generated. Do not edit it. */
function* actionChannel(...args) {
  return yield effects.actionChannel(...args);
}

/* This file is generated. Do not edit it. */
function* flush(...args) {
  return yield effects.flush(...args);
}

/* This file is generated. Do not edit it. */
function* cancelled(...args) {
  return yield effects.cancelled(...args);
}

/* This file is generated. Do not edit it. */
function* setContext(...args) {
  return yield effects.setContext(...args);
}

/* This file is generated. Do not edit it. */
function* getContext(...args) {
  return yield effects.getContext(...args);
}

/* This file is generated. Do not edit it. */
function* delay(...args) {
  return yield effects.delay(...args);
}

/* This file is generated. Do not edit it. */
function* throttle(...args) {
  return yield effects.throttle(...args);
}

/* This file is generated. Do not edit it. */
function* debounce(...args) {
  return yield effects.debounce(...args);
}

/* This file is generated. Do not edit it. */
function* retry(...args) {
  return yield effects.retry(...args);
}

/* This file is generated. Do not edit it. */
function* all(...args) {
  return yield effects.all(...args);
}

/* This file is generated. Do not edit it. */
function* race(...args) {
  return yield effects.race(...args);
}

exports.actionChannel = actionChannel;
exports.all = all;
exports.apply = apply;
exports.call = call;
exports.cancel = cancel;
exports.cancelled = cancelled;
exports.cps = cps;
exports.debounce = debounce;
exports.delay = delay;
exports.flush = flush;
exports.fork = fork;
exports.getContext = getContext;
exports.join = join;
exports.put = put;
exports.putResolve = putResolve;
exports.race = race;
exports.retry = retry;
exports.select = select;
exports.setContext = setContext;
exports.spawn = spawn;
exports.take = take;
exports.takeEvery = takeEvery;
exports.takeLatest = takeLatest;
exports.takeLeading = takeLeading;
exports.takeMaybe = takeMaybe;
exports.throttle = throttle;
